import { Component, OnInit } from '@angular/core';
import { NzDrawerService } from 'ng-zorro-antd/drawer';
import { Cell } from '../../cell';
import { LayoutService } from '../../layout.service';

@Component({
  selector: 'app-cell-selection-checkbox',
  templateUrl: './cell-selection-checkbox.component.html',
  styleUrls: ['./cell-selection-checkbox.component.less']
})
export class CellSelectionCheckboxComponent extends Cell {
  constructor(
    public layoutService: LayoutService,
    public drawerService: NzDrawerService
  ) {
    super(layoutService, drawerService);
  }
}
